import React from "react"
import { useSelector } from "react-redux"
import { Button } from "reactstrap"
import { toggleTime } from "../../api/socket/functions"
import { getSportsConfig } from "../../utility/constants/sportConfig"

function EndDialogContent({ dismissModal, unPause }) {
	const { halftime, notStarted } = useSelector((state) => state.time)
	const { numOfHalftimes, overtimeMinutes, penalties } = getSportsConfig(
		localStorage.getItem("sport")
	)
	const spectate = localStorage.getItem("spectate")

	if (!notStarted) {
		return (
			<>
				<h2>Utakmica je pauzirana</h2>
				<p></p>

				<Button.Ripple
					color="primary"
					size="lg"
					outline
					onClick={dismissModal}
				>
					Uredu
				</Button.Ripple>
			</>
		)
	}

	const onOvertime = () => {
		toggleTime({ toggleOvertime: true })
		if (dismissModal) dismissModal()
	}

	const onPenaltiesOrEnd = (value) => {
		toggleTime({ isPaused: true, penaltiesOrEnd: value })
		if (dismissModal) dismissModal()
	}

	if (numOfHalftimes <= halftime) {
		return (
			<>
				<h1>Utakmica je gotova</h1>
				{!spectate && (
					<>
						<p>Biraj opciju koju želiš</p>
						<div
							style={{
								marginTop: "2em",
								display: "flex",
								flexDirection: "column",
								gap: "1em",
							}}
						>
							{overtimeMinutes && (
								<Button.Ripple
									color="primary"
									size="lg"
									onClick={() => onOvertime()}
								>
									Produžetak od {overtimeMinutes} minuta
								</Button.Ripple>
							)}

							{penalties && (
								<Button.Ripple
									color="primary"
									size="lg"
									onClick={() => onPenaltiesOrEnd("penalties")}
								>
									Penali
								</Button.Ripple>
							)}
							<Button.Ripple
								color="primary"
								size="lg"
								onClick={() => onPenaltiesOrEnd("end")}
							>
								Završi
							</Button.Ripple>
							{dismissModal && (
								<Button.Ripple
									color="secondary"
									size="lg"
									outline
									onClick={dismissModal}
								>
									Odustani
								</Button.Ripple>
							)}
						</div>
					</>
				)}
			</>
		)
	}

	if (dismissModal) {
		return (
			<>
				{halftime === 0 ? (
					<>
						<h1>Utakmica nije započela</h1>
						<p>Kada si spreman, započni utakmicu</p>
					</>
				) : (
					<>
						<h1>Poluvrijeme je gotovo</h1>
						<p>Kada si spreman, započni iduće poluvrijeme</p>
					</>
				)}

				<Button.Ripple
					color="primary"
					size="lg"
					outline
					onClick={dismissModal}
				>
					Uredu
				</Button.Ripple>
			</>
		)
	}

	// * Everything under is if the game hasnt ended
	let text = "Utakmica nije još započela"

	if (numOfHalftimes > 0 && halftime !== 0) {
		if (numOfHalftimes === 2)
			text = `${halftime + 1}. poluvrijeme još nije započelo`
		else if (numOfHalftimes === 4)
			text = `${halftime + 1}. četvrtina još nije započela`
		else text = `${halftime + 1}. dio još nije započeo`
	}

	return (
		<>
			<h1>{text}</h1>
			<p>Klikni na &quot;Započni&quot; ispod, ili na play gumb iznad.</p>
			{!spectate && (
				<Button.Ripple color="primary" size="lg" onClick={unPause}>
					Započni
				</Button.Ripple>
			)}
		</>
	)
}

export default EndDialogContent
